import r from "react";
import { Flex as o } from "../Flex/Flex.js";
const t = _ref => {
  let {
    children: e
  } = _ref;
  return r.createElement(o, {
    className: "olx-price-reference-ruler__tooltip",
    flexDirection: "column",
    alignItems: "center"
  }, e);
};
export { t as PriceTooltip };